import type ApiResponse from "../../api/types/ApiResponse";

export enum MessageType {
  CalculationCompleted = "CalculationCompleted",
  CalculationDeleted = "CalculationDeleted",
  ConstructionAccepted = "ConstructionAccepted",
  ConstructionUnaccepted = "ConstructionUnaccepted",
  ConstructionUpdated = "ConstructionUpdated",
  ConstructionCalculationUpdated = "ConstructionCalculationUpdated",
  ConstructionCalculationUnaccepted = "ConstructionCalculationUnaccepted",
  DrillholesCodeUpdated = "DrillholesCodeUpdated",
  ConstructionDeleted = "ConstructionDeleted",
  DocumentFeedFunctionFailed = "DocumentFeedFunctionFailed",
}

export interface IISaacSignalRMessage {
 constructionId: string;
  calculationId: string;
  status?: string;
}

export interface SignalRMessage extends ApiResponse<IISaacSignalRMessage> {
  id: string;
  isRead: boolean; 
  message: string;
  timeStamp: string;
  type: MessageType;
}
